import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountType, PlatformRole, AccountAmountInfo } from 'common/types';
import { UserRoleType } from 'common/constants';
import { RootState } from './rootReducer';

interface UserInitialState {
  company: any;
  chargeAmount: number;
  incomeScore: number;
  rechargeModalShow: boolean;
  userInfo?: AccountType;
  isAdmin: boolean;
  userRole: UserRoleType;
  accountAmountInfo?: AccountAmountInfo;
  userInfoLoading?: boolean;
  totalIncome: number;
  totalConsume: number;
}

const initialState: UserInitialState = {
  company: null,
  chargeAmount: 0,
  incomeScore: 0,
  rechargeModalShow: false,
  isAdmin: false,
  // 从localstorage取tiangong-user-role 如果不存在则UserRoleType.Allocator
  userRole: (localStorage.getItem('tiangong-user-role') as UserRoleType)
    ? JSON.parse(localStorage.getItem('tiangong-user-role') as string)
    : UserRoleType.Allocator,
  accountAmountInfo: {
    chargeAmount: 0,
    incomeScore: 0,
    chargeCreditLimitBalance: 0,
    chargeCreditLimitTotal: 0,
    withdrawLimit: 0,
    monthWithdrawAmount: 0,
    monthWithdrawLeft: 0,
    isFreeze: false,
    taskBConsume: 0,
    taskBIncome: 0,
    workshopConsume: 0,
    workshopIncome: 0,
    accountWithdrewScore: 0,
    totalTax: 0,
  },
  userInfoLoading: false,
  totalIncome: 0,
  totalConsume: 0,
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCompany(state, { payload }: PayloadAction<any>) {
      state.company = payload;
    },
    setChargeAmount(state, { payload }: PayloadAction<number>) {
      state.chargeAmount = payload;
    },
    setIncomeScore(state, { payload }: PayloadAction<number>) {
      state.incomeScore = payload;
    },
    setRechargeModalShow(state, { payload }: PayloadAction<boolean>) {
      state.rechargeModalShow = payload;
    },
    setUserInfo(state, { payload }: PayloadAction<AccountType>) {
      state.userInfo = payload;
    },
    setUserInfoLoading(state, { payload }: PayloadAction<boolean>) {
      state.userInfoLoading = payload;
    },
    setIsAdmin(state, { payload }: PayloadAction<boolean>) {
      state.isAdmin = payload;
    },
    setUserRole(state, { payload }: PayloadAction<UserRoleType>) {
      state.userRole = payload;
    },
    setAccountAmountInfo(state, { payload }: PayloadAction<AccountAmountInfo>) {
      state.accountAmountInfo = payload;
    },
    setTotalIncome(state, { payload }: PayloadAction<number>) {
      state.totalIncome = payload;
    },
    setTotalConsume(state, { payload }: PayloadAction<number>) {
      state.totalConsume = payload;
    },
  },
});

export const {
  setCompany,
  setChargeAmount,
  setIncomeScore,
  setRechargeModalShow,
  setIsAdmin,
  setUserInfo,
  setUserRole,
  setAccountAmountInfo,
  setUserInfoLoading,
  setTotalIncome,
  setTotalConsume,
} = user.actions;
export const selectCompany = (state: RootState) => state.user.company;
export const selectChargeAmount = (state: RootState) => state.user.chargeAmount;
export const selectIncomeScore = (state: RootState) => state.user.incomeScore;
export const selectRechargeModalShow = (state: RootState) => state.user.rechargeModalShow;
export const selectUserInfo = (state: RootState): AccountType | undefined => state.user?.userInfo;
export const selectIsAdmin = (state: RootState) => state.user.isAdmin;
export const selectIsPlatformAdmin = (state: RootState) =>
  state.user.userInfo?.platformRole?.some(({ roleCode }) => roleCode?.includes(PlatformRole.Admin));
export const selectUserRole = (state: RootState) => state.user.userRole;
export const selectUserInfoLoading = (state: RootState): boolean | undefined => state.user?.userInfoLoading;
export const selectTotalIncome = (state: RootState) => state.user.totalIncome;
export const selectTotalConsume = (state: RootState) => state.user.totalConsume;

export default user.reducer;
